import { lazy, Suspense, useEffect, useState } from "react";
import HomeBanner from "./HomeBanner"
import HomeTeamlogo from "./HomeTeamlogo"
const HomeCar = lazy(() => import("./HomeCar"));
const HomeLab = lazy(() => import("./HomeLab"));
const HomeSolution = lazy(() => import("./HomeSolution"));
const HomeSoftware = lazy(() => import("./HomeSoftware"));
const HomeBusiness = lazy(() => import("./HomeBusiness"));
const HomePlatform = lazy(() => import("./HomePlatform"));
const HomeTestimonial = lazy(() => import("./HomeTestimonial"));
const HomePrice = lazy(() => import("./HomePrice"));
const HomeGlobal = lazy(() => import("./HomeGlobal"));
const HomeNews = lazy(() => import("./HomeNews"));


const headText = "Our Client Testimonials";
export default function Home() {

  const [isScroll, setIsScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsScroll(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <HomeBanner />
      <HomeTeamlogo />
      <Suspense fallback={
        <div className="loader-only-css">
          <div className="loader-inner-css">
            <div></div>
          </div>
        </div>
      }>
        <HomeCar />
        <HomeLab />
        <HomeSolution />
        {isScroll && (
          <>
            <HomeSoftware />
            <HomeBusiness />
            <HomePlatform />
            <HomeTestimonial headText={headText} />
            <HomePrice />
            <HomeGlobal />
            <HomeNews />
          </>
        )}
      </Suspense>
    </>
  );
}
